/**
 * Vägval mellan Field (mobilappen) och skrivbordsversionen.
 *
 * Visas före inloggningen på telefon och liten surfplatta. Valet kan sparas
 * per enhet i localStorage så att frågan bara kommer en gång.
 * Spec: docs/visions/field-vagval/field-vagval-komponentspec.md
 */
import { useState } from 'react';
import { NYCKEL_POST_LOGIN } from './postLoginRedirect';

export const VERSIONSVAL_NYCKEL = 'kanplan-version-val';
export const VAL_FIELD = 'field';
export const VAL_SKRIVBORD = 'desktop';

// Smalare än 1024 px OCH pekskärm: telefon och iPad på höjden. En dator med
// smalt fönster (mus) och iPad på bredden får ingen fråga.
const MOBIL_MEDIA = '(max-width: 1023px) and (pointer: coarse)';

export function arMobilEnhet() {
  try {
    return typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia(MOBIL_MEDIA).matches;
  } catch {
    return false;
  }
}

export function lasVersionsVal() {
  try {
    const v = localStorage.getItem(VERSIONSVAL_NYCKEL);
    return v === VAL_FIELD || v === VAL_SKRIVBORD ? v : '';
  } catch {
    return '';
  }
}

export function sparaVersionsVal(val) {
  try { localStorage.setItem(VERSIONSVAL_NYCKEL, val); } catch { /* privat läge */ }
}

/**
 * Användaren är på väg någon särskild stans (länk i mejl, inbjudan, fel från
 * Microsoft-inloggningen) — då ska vägvalet inte komma i vägen.
 */
function harEgetMal(location) {
  try {
    if (location?.state?.email) return true;
    const params = new URLSearchParams(window.location.search);
    if (params.get('o365_fel')) return true;
    const postLogin = String(sessionStorage.getItem(NYCKEL_POST_LOGIN) || '').trim();
    if (postLogin && postLogin !== '/' && !postLogin.startsWith('/home/overview')) return true;
  } catch { /* ignore */ }
  return false;
}

/**
 * Avgör vad inloggningssidan ska visa: 'val' (vägvalsskärmen), 'field'
 * (sparat val Field — sidan skickar vidare) eller 'login' (vanliga formuläret).
 */
export function startlage(location) {
  if (!arMobilEnhet() || harEgetMal(location)) return 'login';
  // ?version=skrivbord öppnar alltid formuläret och sparar det valet.
  try {
    if (new URLSearchParams(window.location.search).get('version') === 'skrivbord') {
      sparaVersionsVal(VAL_SKRIVBORD);
      return 'login';
    }
  } catch { /* ignore */ }
  const sparat = lasVersionsVal();
  if (sparat === VAL_FIELD) return 'field';
  if (sparat === VAL_SKRIVBORD) return 'login';
  return 'val';
}

/**
 * Inloggad användare som öppnar "/" (t.ex. via hemskärmsikonen, vars
 * start_url är "/"): ska telefonen till Field i stället för startsidan?
 */
export function skaStartaIField() {
  return arMobilEnhet() && lasVersionsVal() === VAL_FIELD;
}

export function useVersionsVal(location) {
  const [lage, setLage] = useState(() => startlage(location));
  return { lage, visaInloggning: () => setLage('login') };
}
